<template>
  <div class="modal fade" id="cryptoRegistrationCancel" tabindex="-1" aria-labelledby="cryptoRegistrationCancelLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          各種規定や確認事項にすべて承諾または「はい」をご選択いただきますと、取引画面へ進めます。
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="hide()">{{$t("btn.close")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";

export default {
    name: "CryptoRegistrationCancelModal",
    mounted() {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_CRYPTO_REGISTRATION_CANCEL_MODAL, () => {
            this.show();
        });
    },
    methods: {
        show() {
            $("#cryptoRegistrationCancel").modal("show");
        },
        hide() {
            $("#cryptoRegistrationCancel").modal("hide");
        }
    },
}

</script>

<style scoped>
.modal-dialog{
  max-width: 600px !important;
}
</style>
